{
  "exportGeoJson": {
    "exportLayersInfo": "Las capas seleccionadas se están exportando, te avisaremos cuando esté lista"
  },
  "importGeoJson": {
    "invalidGeoJson": {
      "title": "Tipo de archivo no válido",
      "message": "El archivo que has subido no es válido. Cargue un archivo GeoJSON, JSON, GPX o KML/KMZ válido."
    },
    "somethingWentWrong": {
      "title": "Algo salió mal",
      "message": "El tipo de archivo que has subido no es válido. Cargue un archivo GeoJSON, JSON, GPX o KML/KMZ válido."
    },
    "fileTooLarge": {
      "title": "El tamaño del archivo es demasiado grande",
      "message": "El archivo que estás intentando subir es demasiado grande. El tamaño máximo del archivo es {{ size }}"
    },
    "invalidGeometry": {
      "title": "Geometría no válida",
      "message": "El tipo de capa que está intentando cargar tiene una geometría no válida."
    },
    "invalidLayerType": {
      "title": "Tipo de capa incompatible",
      "message": "Estás intentando subir una capa {{ importType }} a una capa {{ layerType }}"
    },
    "invalidCoordinateSystem": {
      "title": "El sistema de coordenadas no es compatible",
      "message": "El sistema de coordenadas no es compatible, utilice {{ coordinateSystem }}"
    },
    "reuploadGeoJson": "La extensión de archivo admitida es {{ fileExtensions }} y el tamaño máximo de archivo es de hasta {{ size }}",
    "mappedAttributeDescription": "Seleccione las propiedades del archivo para importarlas como atributos de capa (opcional).",
    "layerAttribute": "Atributo de capa",
    "type": "Escriba",
    "fieldToImport": "Campo a importar",
    "overwriteExisting": "Sobrescribir el existente",
    "importLayer": "Importar capa"
  },
  "importKML": {
    "invalidKML": {
      "title": "Datos KML no válidos",
      "message": "Los datos KML no son válidos. Compruebe el archivo fuente e inténtelo de nuevo."
    },
    "folderSelectLabel": "Capas de importación predeterminadas",
    "allFolders": "Todas las capas"
  },
  "importGpx": {
    "invalidGpx": {
      "title": "Datos GPX no válidos",
      "message": "Los datos GPX no son válidos. Comprueba el archivo fuente e inténtalo de nuevo."
    },
    "import_track": "Importar pista",
    "import_route": "Ruta de importación"
  },
  "analysis_drawing_tooltips": {
    "title": "Herramientas de análisis",
    "enter_edit_mode": "Utilice las herramientas de dibujo para seleccionar objetos del mapa y analizar áreas, líneas, etc.",
    "enter_edit_mode_link": "Haga clic aquí para obtener más información sobre esta herramienta"
  },
  "dataTableGrouping": {
    "checkbox": "Datos del grupo"
  },
  "assets": {
    "edit": "Editar el activo seleccionado",
    "delete": "Eliminar el activo seleccionado",
    "uploadAsset": "Subir activo",
    "deleteTitleIcon": "Icono de eliminación",
    "deleteDescriptionIcon": "¿Está seguro de que desea eliminar este icono?",
    "deleteTitleModel": "¿Eliminar modelo?",
    "deleteDescriptionModel": "¿Está seguro de que desea eliminar este modo?"
  },
  "toolbarButtonTooltips": {
    "route": "Generador de rutas"
  },
  "routeGenerator": {
    "routeGenerator": "Generador de rutas",
    "distance": "Distancia",
    "travelTime": "Tiempo de viaje",
    "addStop": "Añadir parada",
    "addRoute": "Nueva ruta",
    "removeStop": "Eliminar parada",
    "search": "Busca o haz clic en el mapa"
  },
  "exports": {
    "remarks": {
      "title": "Comentarios personalizados",
      "placeholder": "Inserte comentarios personalizados aquí",
      "error": "Los comentarios son demasiado largos"
    }
  },
  "styles": {
    "modelOffset": "Offset del modelo"
  },
  "attributes": {
    "imageDescription": "Solo puedes subir 1 imagen por atributo. Puedes reemplazar tu selección a continuación.",
    "imageTitle": "Sube la imagen al atributo",
    "noImageSelected": "No se ha seleccionado ningún archivo"
  },
  "layerTemplates": {
    "chosenForYou": "Elegido para ti"
  },
  "contextMenu": {
    "addAttributeMultipleLayers": "Agregar un atributo a todos"
  },
  "importLayers": {
    "folderOutsideMap": "No se puede importar una carpeta desde fuera de un mapa"
  },
  "delete": {
    "multipleTitleMix": "Eliminar varios elementos",
    "multipleDescriptionMix": "Al eliminar un grupo, se eliminarán todas las capas y sus objetos",
    "importLayerHint": "La capa importada solo se eliminará del mapa y permanecerá en el plan original",
    "multipleLayersTitle": "Eliminar varias capas",
    "multipleLayersDescription": "Al eliminar varias capas, también se eliminarán todos los objetos que contienen",
    "multipleImportLayersTitle": "Eliminar las capas importadas",
    "singleImportLayersTitle": "Eliminar la capa importada",
    "importLayersDescription": "Al eliminar la capa importada, solo se eliminarán los objetos del mapa. Puede importar la capa del mapa vinculado en cualquier momento",
    "singleLayerTitle": "Eliminar una capa",
    "singleLayerDescription": "Al eliminar esta capa, también se eliminarán todos los objetos que contiene"
  }
}